export default __webpack_public_path__ + "static/media/Netflix.833f1282.svg";